import { lazy } from 'react'

const lazyImport = (filename) => (
  lazy(() => (import(`../views/${filename}`)))
)

export default lazyImport
